<ng-container *ngFor="let level of levelList">
  <div class="d-flex">
    <h3>{{level === 0 ? 'Cantrips' : 'Level ' + level}}</h3>
    <ul *ngIf="numSlots && level !== 0" class="m-0 ml-2 p-0 pt-2">
      <li *ngFor="let slot of numSlots.get(level)" class="slot shadow-sm clickable"
          [ngClass]="slot === 1 ? 'active' : 'inactive'"
          (click)="slot === 1 ? slotToggle(false, level) : slotToggle(true, level)"></li>
    </ul>
  </div>
  <div class="card pl-3 pr-3 pb-3 pt-2 mb-4">
    <ng-container *ngFor="let spell of spells; let i = index">
      <div *ngIf="spell.level === level">
        <div [ngClass]="i !== selectedSpellIndex ? 'border-bottom' : ''"
             class="d-flex justify-content-between clickable pt-2 align-text-bottom">
          <div (click)="showSpell(i)" class="d-flex justify-content-between w-100 align-items-start">
            <p class="font-weight-bold text-wrap my-2">{{spell.name}}</p>
          </div>

          <fa-icon (click)="showSpell(i)" [icon]="selectedSpellIndex !== i ? faAngleDown : faAngleUp"
                   class="fa mr-1" style="font-size: 1.25em"></fa-icon>
        </div>
        <div *ngIf="i === selectedSpellIndex" class="d-flex flex-column bg-light pt-2 pr-3 pl-3 border pb-2 slide"
             style="font-size: 0.8em" id="spellForm" @slideUpDown>
          <div *ngIf="selectedSpellIndex === i">
            <em>School of {{spell.school.charAt(0).toUpperCase() + spell.school.substring(1)}}</em><br><br>
            <p>
              <span *ngIf="spell.casting_time"><strong>Casting Time: </strong>{{spell.casting_time}}<br></span>
              <span *ngIf="spell.range"><strong *ngIf="spell.range">Range: </strong>{{spell.range}}<br></span>
              <span *ngIf="spell.duration"><strong *ngIf="spell.duration">Duration: </strong>{{spell.duration}}<br></span>
              <span *ngIf="spell.components"><strong *ngIf="spell.components">Components: </strong>{{spell.components['raw']}}<br></span>
              {{spell.description}}
            </p>
          </div>
          <div class="w-100">
            <fa-icon *ngIf="!characterCreate" (click)="editSpell(i)" [icon]="faPencil"
                     class="fa mr-2 float-right clickable" style="font-size: 1.25em"></fa-icon>
            <button *ngIf="characterCreate" class="btn btn-sm btn-main text-white float-right" (click)="addSpell(spell)">
              Add Spell
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
